<template>
	<footer>
		<div ref="footer" class="footer">
			Made with <span><i class="fas fa-heart"></i></span> by Achraf Gaoubouzi using Vuejs
		</div>
	</footer>
</template>

<script>
import { TimelineMax } from 'gsap';

export default {
	data() {
		return {};
	},
	mounted() {
		const footer = this.$refs.footer;

		const tm = new TimelineMax();

		tm.fromTo(footer, 3, { opacity: 0, y: 30 }, { opacity: 0.3, y: 0 });
	},
};
</script>

<style lang="scss" scoped>
footer {
	min-width: 100vw;
	.footer {
		bottom: 0;
		padding-bottom: 10px;
		color: rgb(255, 255, 255);
		position: absolute;
		text-align: center;
		font-family: Nunito, sans-serif;
		font-weight: 700;
		min-width: 100%;
		font-size: 12px;
		opacity: 0.3;
	}
}

// --------------------------Responsive-------------------------

@media (max-width: 480px) {
	footer {
		.footer {
			font-size: 9px;
		}
	}
}

//----------------------Heart animation---------------

.fa-heart {
	width: 15px;
	-webkit-transition: all ease 0.3s;
	-moz-transition: all ease 0.3s;
	transition: all ease 0.3s;

	&:before {
		animation: heartMoving 1.5s infinite;
	}
}

@keyframes heartMoving {
	0% {
		color: rgb(255, 255, 255);
		font-size: 12px;
	}
	100% {
		color: #ff4136;
		font-size: 16px;
	}
}
</style>
